module.exports = {};


//////////////////
// WEBPACK FOOTER
// external "{}"
// module id = 27
// module chunks = 0